<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-overlay>
          <component :is="errorMessage" :error="error"/>
        </v-overlay>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ErrorMessageDefault from './ErrorMessageDefault.vue'
import ErrorMessageSDM404 from './ErrorMessageSDM404.vue'

export default {
  name: 'ErrorView',
  props: {
    error: {
      type: Error,
      default: null
    }
  },
  computed: {
    errorMessage () {
      let component
      const status = this.error?.statusCode || null
      switch (status) {
        case 404:
          component = ErrorMessageSDM404
          break
        default:
          component = ErrorMessageDefault
          break
      }
      return component
    }
  }
}
</script>
